import { LandingModelService } from './../services/landingModel.service';
import { Injector, Input, Directive } from '@angular/core';
import { ScreenType } from '../model/ScreenType';
import { UpaService } from '../services/upa.service';
import { Module } from '../model/ModuleModel';

@Directive()
export abstract class AbstractComponent {
  @Input() product: any;
  @Input() flow: any;
  @Input() module: Module<any>;

  keywordsMap: { [key: string]: string; };

  landingModelService: LandingModelService;
  screenType: ScreenType;
  upaService: UpaService;

  abstract getModuleId(): string;

  constructor(private injector: Injector) {
    this.landingModelService = this.injector.get(LandingModelService);
    this.upaService = this.injector.get(UpaService);
    this.screenType = this.landingModelService.getLandingModel().device.type;
    this.keywordsMap = this.landingModelService.getLandingModel().keywordsMap;
  }
}
